import { BottomSheetModal } from "@reconvert/react-ui-component";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectBottomSheet, closeBottomSheet, BottomSheetType, BOTTOM_SHEET_TYPES } from "../../app/slice/mobileSlice";
import { useDirection } from "../../hooks/useDirection";
import AddConditionView from "../CheckoutPage/components/ConditionCreationSidebar/AddConditionView";
import EditConditionView from "../CheckoutPage/components/ConditionCreationSidebar/EditConditionView";
import MobileQuickSetup from "./MobileQuickSetup";
import useUnsavedBar from "../../hooks/useUnsavedBar";

const SHEET_CONFIG: Record<NonNullable<BottomSheetType>, { maxHeight?: string; fitContent?: boolean }> = {
  [BOTTOM_SHEET_TYPES.ADD_CONDITION]: { maxHeight: "90vh" },
  [BOTTOM_SHEET_TYPES.EDIT_CONDITION]: { maxHeight: "90vh" },
  [BOTTOM_SHEET_TYPES.DATE_RANGE_PICKER]: { maxHeight: "60vh", fitContent: true },
  [BOTTOM_SHEET_TYPES.QUICK_SETUP]: { maxHeight: "70vh", fitContent: true },
};

const MobileBottomSheet = () => {
  const dispatch = useAppDispatch();
  const { preventAction } = useUnsavedBar()
  const bottomSheet = useAppSelector(selectBottomSheet);
  const { direction } = useDirection();

  if (!bottomSheet.type) return null;

  const config = SHEET_CONFIG[bottomSheet.type as NonNullable<BottomSheetType>] ?? {};

  const renderContent = () => {
    switch (bottomSheet.type) {
      case BOTTOM_SHEET_TYPES.ADD_CONDITION:
        return <AddConditionView />;
      case BOTTOM_SHEET_TYPES.EDIT_CONDITION:
        return <EditConditionView />;
      case BOTTOM_SHEET_TYPES.DATE_RANGE_PICKER:
      case BOTTOM_SHEET_TYPES.QUICK_SETUP:
        return <MobileQuickSetup slot={bottomSheet.props?.slot ?? null} />;
      default:
        return null;
    }
  };

  return (
    <BottomSheetModal
      onClose={() => preventAction(() => dispatch(closeBottomSheet()))}
      closeOnOverlayClick={false}
      showDragHandle={false}
      direction={direction}
      maxHeight={config.maxHeight}
      fitContent={config.fitContent}
      defaultPeekExpanded
      resetExpandedOnClose={false}
    >
      {renderContent()}
    </BottomSheetModal>
  );
};

export default MobileBottomSheet;
